module.exports = "/virtual-football-league/img/betting-virtualf-games-holder-bar.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/betting-virtualf-games-holder-bar.png
// module id = 2237
// module chunks = 4